
<template>
  <base-card>
    <template slot="title">
      {{ $t('projects.doing')}}
    </template>
    <template v-slot:content>
      <div v-if="!loading && projects.length">
        <project-small-card v-for="project in projects" :key="project.id" :project="project" class="mb-3"></project-small-card>
      </div>
      <card-loading-transparent v-if="loading"></card-loading-transparent>
      <div v-if="!loading && !projects.length">
        {{ $t('projects.none') }}
      </div>
    </template>
    <template slot="actions">
      <v-btn text small class="text-capitalize" color="blue-grey" :to="{name: 'Projects'}">{{ $tc('see_all',0) }}</v-btn>
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'ProjectsDoingCard',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      projects: [],
    }
  },
  methods: {
    getProjects() {
      this.loading = true
      Api.Project.index({status: ['doing', 'waiting', 'overdue'], limit: 10}).then(r=> r.data).then(d => {
        this.projects = [...d]
      }).finally(()=> {
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getProjects()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>